import styled from 'styled-components';
import { TextareaAutosize } from '@mui/material';
import { NumberInputField } from '@shared/fields/NumberInputField';
import { colorTheme } from '@styles/muiTheme';

export const ExcludedLenderWrapper = styled.div`
  font-size: 14px;
  padding: 20px;
  border-bottom: 1px solid ${colorTheme.palette.grey[500]};

  button {
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover {
    button {
      opacity: 1;
    }
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const ExcludedLenderHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  justify-content: space-between;
`;

export const ExcludedLenderText = styled(TextareaAutosize)`
  display: block;
  border: none;
  outline: none;
  width: 100%;
  max-height: 140px;
  padding: 11px 10px;
  resize: none;
  font-size: 14px;
  color: ${colorTheme.palette.common.black};
  font-family: Open Sans;
  outline: 1px solid ${colorTheme.palette.grey[500]};
  border-radius: 4px;
  margin-bottom: 10px;
`;

export const ExcludedLenderFooter = styled.div`
  color: ${colorTheme.palette.primary.light};
  font-weight: 700;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
`;

export const FooterSection = styled.div`
  background: ${colorTheme.palette.secondary.light};
  width: calc(100% + 60px);
  padding-left: 25px;
  margin-left: -25px;
`;

export const LenderSectionWrapper = styled.div<{ selected?: boolean }>`
  min-width: 220px;
  max-width: 220px;
  margin-bottom: 10px;
  padding: 0 20px 10px;
  border-radius: 4px;

  &:hover {
    cursor: pointer;
  }

  &:last-child {
    ${FooterSection} {
      padding-right: 20px;
      border-radius: 0 8px 8px 0;
    }
  }

  ${({ selected }) =>
    selected &&
    `
    outline: 1px solid ${colorTheme.palette.grey[500]};
    background: ${colorTheme.palette.secondary.light};
    position: relative;
    z-index: 1;
  `}

  .MuiInputBase-root {
    height: 29px;
    border-radius: 4px;
  }
`;

export const LenderSectionRow = styled.div`
  height: 40px;
  display: flex;
  align-items: center;
`;

export const LenderSectionRowValidation = styled(LenderSectionRow)`
  border-radius: 4px;
  padding-left: 5px;
  height: 29px;
  margin: 1px 0 10px 0;
`;

export const LenderSectionDivider = styled.div<{ dense?: boolean }>`
  margin: ${({ dense }) => (dense ? '20px 0' : '20px -20px')};
  width: ${({ dense }) => (dense ? '100%' : 'calc(100% + 40px)')};
  border-bottom: 1px solid ${colorTheme.palette.grey[500]};
`;

export const SalesTaxField = styled(NumberInputField)`
  .MuiInputBase-root {
    padding-right: 0px;
  }
`;

export const LenderbuttonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
